<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2">By</span> J<span class="t3">ON</span> K<span class="t3">EYS</span></p>
<p class="p0"><span class="t2">Home Grown</span></p>
<p class="p0"><span class="t2">Heart of the Pines</span></p>
<p class="p0"><span class="t2">Obsidian Sun</span></p>
<p class="p2"><span class="t2">Published by</span> D<span class="t3">REAMSPINNER</span> P<span class="t3">RESS</span></p>
<p class="p0"><span class="t2">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?45883cbb